import React from 'react';
import {observer} from "mobx-react-lite";
import {useRootStore} from "@stores/AppStateContext";

import {WorkspaceSelect} from "../../../components/WorkspaceSelect/WorkspaceSelect";
import {ProfileIcon} from "../../../elements/RightMenu/ProfileIcon";
import {NotificationButton} from "../../context-menu/NotificationPanel/NotificationButton"

export const MainSidebarMobileHeader = observer(() => {
    const rootStore = useRootStore();
    const root = rootStore;
    return (
        <div className={'MobileHeader theme-dark'}>
            <WorkspaceSelect key={`${root.isReady}`}/>
            <NotificationButton className={"hm_button"}/>
            <ProfileIcon className={'MobileHeader__button'}/>
        </div>
    )
})
